import React from "react";
import { Calendar, MessageSquare, CreditCard } from "lucide-react";
import { ComingSoon } from "@/components/dashboard/DashboardLayout";

export const InterviewScheduling = () => (
    <ComingSoon
        icon={Calendar}
        testId="coming-scheduling"
        title="Interview Scheduling"
        description="Bookable interview slots synced with Google Calendar + Outlook. Candidates pick a time, calendars stay clean, and every interview appears back in your Candidate Pipeline automatically."
        waitlist
    />
);

export const TeamCollaboration = () => (
    <ComingSoon
        icon={MessageSquare}
        testId="coming-team"
        title="Team Collaboration"
        description="Invite hiring managers + department leads as scoped teammates. They can review Talent Passports, watch candidate videos, leave comments, rate candidates, and vote on finalists — all without touching billing or job creation."
        waitlist
    />
);

export const Billing = () => (
    <ComingSoon
        icon={CreditCard}
        testId="coming-billing"
        title="Billing"
        description="Manage your Simonara subscription, per-verification purchases, and invoice history from one place. Stripe-powered, receipts on demand, plan upgrades in seconds."
        waitlist
    />
);
